import { render, staticRenderFns } from "./TableComponentBuefy.vue?vue&type=template&id=5faf00f2&scoped=true&"
import script from "./TableComponentBuefy.vue?vue&type=script&lang=js&"
export * from "./TableComponentBuefy.vue?vue&type=script&lang=js&"
import style0 from "./TableComponentBuefy.vue?vue&type=style&index=0&id=5faf00f2&lang=sass&scoped=true&"
import style1 from "./TableComponentBuefy.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf00f2",
  null
  
)

export default component.exports